//  https://chargify.zendesk.com/hc/en-us/articles/4407870802331-Currency#supported-currencies
import { ZERO_DECIMAL_CURRENCIES } from './constants';

export const CURRENCY_MAP = {
  AUD: '$',
  BRL: 'R$',
  CAD: '$',
  CHF: 'Fr.',
  CNY: '¥',
  CZK: 'Kč',
  DKK: 'DKK',
  EUR: '€',
  GBP: '£',
  HKD: '$',
  INR: '₹',
  JPY: '¥',
  MXN: '$',
  MYR: 'RM',
  NOK: 'kr',
  NZD: '$',
  PHP: '₱',
  PLN: 'zł',
  RON: 'Lei',
  RUB: '₽',
  SEK: 'kr',
  SGD: '$',
  USD: '$',
  ZAR: 'R',
  AED: 'د.إ',
  SAR: 'ر.س',
  ILS: '₪',
} as const;

export type Currency = keyof typeof CURRENCY_MAP;

/**
 * Formats currency to its symbol
 * @param {Currency} currency
 * @param {number} value
 * @param {string} locale language tag, by default it is set to 'en'
 * @returns {string} formatted value with currency symbol
 */
export const formatCurrency = (
  currency: Currency,
  value: number,
  locale: string = 'en'
) => {
  const valueToFormat = ZERO_DECIMAL_CURRENCIES.includes(currency)
    ? value
    : value / 100;
  return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(
    valueToFormat
  );
};
